import classNames from 'classnames';
import { PhoneRegex } from 'common/validation';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { MerchantAdmin } from './addMerchantRequest';

export interface MerchantAdminEditorProps {
    admins: MerchantAdmin[];
    onAdd(admin: MerchantAdmin): void;
    onRemove(admin: MerchantAdmin): void;
    showValidationErrors: boolean;
}

const MerchantAdminEditor: React.FC<MerchantAdminEditorProps> = props => {
    const [adminToAdd, setAdminToAdd] = useState<MerchantAdmin>(getDefaultAdmin());


    function onClickAdd() {
        props.onAdd(adminToAdd);
        setAdminToAdd(getDefaultAdmin());
    }

    return <div>
        <Form as="div" inline validated>
            <Form.Control size='sm'
                value={adminToAdd.firstName}
                className="mr-1" placeholder="First Name" onChange={ev => setAdminToAdd({...adminToAdd, firstName: ev.target.value})} />
            <Form.Control  size='sm'
                value={adminToAdd.lastName}
                className="mr-1" placeholder="Last Name" onChange={ev => setAdminToAdd({...adminToAdd, lastName: ev.target.value})} />
            <Form.Control type="email"  size='sm'
                value={adminToAdd.email}
                className="mr-1" placeholder="Email" onChange={ev => setAdminToAdd({...adminToAdd, email: ev.target.value})} />
            <Form.Control size='sm'
                pattern={PhoneRegex.source}
                value={adminToAdd.phone}
                className="mr-1" placeholder="Phone" onChange={ev => setAdminToAdd({...adminToAdd, phone: ev.target.value})} />
            <button className="btn"
                onClick={onClickAdd}
                disabled={!isValid(adminToAdd) || props.admins.some(a => a.email === adminToAdd.email)}>
                <i className="material-icons">add</i>
            </button>
        </Form>
        
        {props.admins.map((admin, i) => 
            <div key={i} className="row">
                <div className="col-6">
                    {admin.firstName} {admin.lastName}
                    <span className="pl-2">
                        {admin.email} / {admin.phone}
                    </span>
                </div>
                <div className="col">
                    <button className='link-button mr-auto' onClick={() => props.onRemove(admin)}>
                        <i className="material-icons">delete</i>
                    </button>
                </div>
            </div>)}
        {props.admins.length === 0 && <div className={classNames({"error-text": props.showValidationErrors})}>At least one admin is required</div>}
    </div>
}

function isValid(admin: MerchantAdmin): boolean {
    return admin.firstName?.length > 0 &&
        admin.lastName?.length > 0 &&
        admin.email?.length > 0 &&
        admin.phone?.length > 0;
}

function getDefaultAdmin(): MerchantAdmin {
    return {
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
    }
}

export default MerchantAdminEditor;